import { defineManifest } from '@ndrc/app-sdk/manifest';
import { emitsOf } from '@ndrc/app-sdk/events';
import { events } from './events.js';
import fr from './messages/fr.json' with { type: 'json' };
export const manifest = defineManifest({
  id: 'reputation',
  name: fr.title,
  description: fr.description,
  icon: 'grid',
  color: '#B45309',
  version: '0.1.0',
  sdk: '0.0.0',
  status: 'dev',
  category: 'pedagogie',
  permissions: { uses: ['app.records.read', 'app.records.write'], defines: [] },
  entities: {
    uses: [],
    owns: [
      'cases',
      'watches',
      'crises',
      'history',
      'receipts',
      'milestones',
      'social_responses',
    ].map((table) => ({
      table,
      scope: 'workspace' as const,
      description: fr.description,
    })),
  },
  events: {
    emits: emitsOf(events),
    subscribes: [{ type: 'social_studio.review.referred', handler: 'onSocialReferral' }],
  },
  ui: {
    student: { defaultRoute: '/', routes: [{ path: '/', title: fr.title }], layout: 'full' },
    teacher: { panel: true, widgets: [], studentInspector: true },
  },
  missions: { actions: ['reputation.seed'], conditions: ['reputation.completed'], blocks: [] },
  migrations: { schema: 'app_reputation', dir: 'migrations' },
});
